<template>
    <div> 
        <b-navbar class="navbar" toggleable="lg" type="dark" variant="primary">
            <b-navbar-brand to="/">AsapCash</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/cliente" v-if="level!=='cliente'">Clientes</b-nav-item>
                    <b-nav-item-dropdown text="Orçamentos">
                        <b-dropdown-item to="/novoOrcamento" v-if="level==='cliente'">Novo Orçamento</b-dropdown-item>
                        <b-dropdown-item to="/orcamentos" v-if="level==='admin'">Listar Orçamentos</b-dropdown-item>
                        <b-dropdown-item to="/propostas" v-if="level==='cliente'">Listar Propostas</b-dropdown-item>
                        <b-dropdown-item to="/aceitos" v-if="level==='admin'">Propostas Aceitas</b-dropdown-item>
                        <b-dropdown-item to="/aceitosCliente" v-if="level==='cliente'">Transportes Aceitos</b-dropdown-item>
                        <b-dropdown-item to="/orcamentosCliente" v-if="level==='cliente'">Transportes em Análise</b-dropdown-item>
                        <b-dropdown-item to="/rejeitados" v-if="level==='admin'">Propostas Rejeitadas</b-dropdown-item>
                        <b-dropdown-item to="/estornados" v-if="level==='admin'">Propostas Estornadas</b-dropdown-item>
                        <b-dropdown-item to="/baixados" v-if="level==='admin'">Propostas Baixadas</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown text="Cargas e Caminhões" v-if="level==='admin'">
                        <b-dropdown-item to="/cargas" v-if="level==='admin'">Cargas</b-dropdown-item>
                        <b-dropdown-item to="/caminhoes" v-if="level==='admin'">Caminhões</b-dropdown-item>
                        <b-dropdown-item to="/cargasPorCaminhao" v-if="level==='admin'">Cargas por Caminhão</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown :text="nome" right>
                        <b-dropdown-item to="/configs" v-if="level==='admin'">Configuração</b-dropdown-item>
                        <b-dropdown-item to="/empresa" v-if="level==='admin'">Empresa</b-dropdown-item>
                        <b-dropdown-item to="/notificacoes" v-if="level==='admin'">Notificações</b-dropdown-item>
                        <b-dropdown-divider v-if="level==='admin'"/>
                        <b-dropdown-item to="/me">Meus Dados</b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item to="/senha">Alterar Senha</b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item href @click.prevent="logout">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: "Menu",
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            nome: ''
        }
    },
    methods: {
        logout () {
            this.$toasted.global.defaultSuccess({ message : 'Logout Realizado com sucesso!' })
            localStorage.removeItem('__SYSTEM_USER')
            this.$router.push({ name: 'login' })
            this.$store.commit('toggleVisible', false)
        }
    },
    mounted() {
        const local = localStorage.getItem('__SYSTEM_USER')
        const decodedToken = this.jwt.decodeToken(local)
        if (local === null) {
            this.$router.push({ path: '/login' })
            this.$store.commit('toggleVisible', false)
        } else {
            this.level = decodedToken['data'].level
            this.nome = decodedToken['data'].nome
            this.$store.commit('toggleVisible', true)
        }
    }
}
</script>

<style>
.navbar {
    z-index: 9;
}

nav.navbar.navbar-dark.bg-primary.navbar-expand-lg {
    background-color: #313177 !important;
}


</style>